import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.routes').then(m => m.homeRoutes),
    data: { preload: true },
    title: 'loiane.training',
  },
  {
    path: 'cursos',
    loadChildren: () => import('./features/courses/courses.routes').then(m => m.coursesRoutes),
    title: 'Cursos | loiane.training',
  },
  {
    path: 'curso',
    redirectTo: 'cursos',
    pathMatch: 'prefix',
  },
  {
    path: 'sobre',
    loadChildren: () => import('./features/about/about.routes').then(m => m.aboutRoutes),
    title: 'Sobre | loiane.training',
  },
  {
    path: 'ajuda',
    loadChildren: () => import('./features/help/help.routes').then(m => m.helpRoutes),
    title: 'Ajuda | loiane.training',
  },
  {
    path: 'sessao',
    loadChildren: () => import('./features/session/session.routes').then(m => m.SESSION_ROUTES),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  },
  {
    path: 'continuar-curso',
    loadChildren: () => import('./features/continue-course/continue-course.routes').then(m => m.CONTINUE_COURSE_ROUTES),
  },
  {
    path: 'certificado',
    loadChildren: () => import('./features/certificate/certificate.routes').then(m => m.CERTIFICATE_ROUTES),
  },
  {
    path: '**',
    loadComponent: () => import('./features/session/not-found/not-found').then(m => m.NotFound),
    title: 'Página não encontrada | loiane.training',
  },
];
